import React, { Component } from "react";
import { fixRelativePath } from "../../utils/bullseyeUtils";
import "./coupon.scss";
import { FiletypePdf } from "react-bootstrap-icons";

// Define an interface for the component props
interface CouponProps {
  key?: number | null;
  couponImage?: string | null;
  couponName?: string | null;
  couponText?: string | null;
  locationName?: string | null;
  address1?: string | null;
  city?: string | null;
  stateAbbr?: string | null;
  postCode?: string | null;
  phone?: string | null;
}

/** This is a class component because the print functionality
 * only accepts class components
 */
class Coupon extends Component<CouponProps> {
  private componentRef = React.createRef<HTMLDivElement>();

  render() {
    const {
      key,
      couponImage,
      couponName,
      couponText,
      locationName,
      address1,
      city,
      stateAbbr,
      postCode,
      phone,
    } = this.props;
    const isPdf = couponImage && couponImage.endsWith(".pdf");

    return (
      <div
        key={key}
        className="container coupon__promoPrint mt-2"
        ref={this.componentRef}
      >
        {couponImage && (
          <div className="row image-container">
            <div className="col-12">
              {isPdf ? (
                <a
                  className="no-print"
                  href={couponImage}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiletypePdf
                    className="img-fluid"
                    style={{ width: 50, height: 50 }}
                  />
                </a>
              ) : (
                <img
                  className="img-fluid"
                  alt="coupon"
                  src={fixRelativePath(couponImage)}
                />
              )}
            </div>
          </div>
        )}
        <div className="row coupon_backgroundContainer">
          <div className="col-12">
            <h4 style={{ textAlign: "center" }}>{couponName}</h4>
            <span>{couponText}</span>
          </div>
          <div className="col-12 col-md-6 coupon__information">
            <br />
            <span
              className="coupon__locationName"
              style={{ fontWeight: "bold" }}
            >
              {locationName} <br />
            </span>
            <span className="coupon__address1">{address1}</span>
            <br />
            <span className="coupon__direction">
              {city}, {stateAbbr} {postCode}
            </span>
          </div>
          {phone && phone.length > 0 && (
            <div className="col-12 col-md-6">
              <br />
              <span className="coupon__contact" style={{ fontWeight: "bold" }}>
                Contact
              </span>
              <br />
              <span className="coupon__phoneNumber">{phone}</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Coupon;
